module.exports = "//static.hsappstatic.net/LoginUI/static-1.14998/img/circle_desktop.svg"